import { ACTION } from "@/lib/auth/actions";
import { hasPermission } from "@/lib/authv2/permissions";

/**
 * Ai mở được màn Năng suất nhân sự (QĐ 0386).
 *
 * Đây chỉ là CỬA: lead, QC, trưởng cửa hàng, giám đốc, quản trị cùng mang
 * `staff_productivity.read`, nhưng mỗi người thấy ai là do máy chủ cắt — lead
 * phòng mình, trưởng cửa hàng nhân viên cơ sở mình, giám đốc tất cả.
 */
export function canSeeStaffProductivity(): boolean {
  return hasPermission(ACTION.StaffProductivityRead);
}

/**
 * Ai đặt được trần nhận việc. Máy chủ trả sẵn cờ `canSetCapacity` trên bảng —
 * màn đọc CỜ ĐÓ trước; hàm này chỉ là rào cùng hướng khi vé chưa mang quyền.
 */
export function canSetStaffCapacity(): boolean {
  return hasPermission(ACTION.StaffProductivityCapacityWrite);
}
